module.exports = __webpack_public_path__ + "img/logo_icon.e321e959.png";